import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { UnitTransferDocumentReviewDecisionEnumType } from '__generated__/graphql';
import { FC, useState } from 'react';

import Button from 'primitives/Button';
import ConfirmButton from 'primitives/ConfirmButton';
import { Dialog, DialogActions, DialogPanel, DialogTitle } from 'primitives/Dialog';
import TextArea from 'primitives/TextArea';

import ErrorMessage from 'components/ErrorMessage';

const REVIEW_UNIT_TRANSFER_DOCUMENT_MUTATION = gql(`
  mutation ReviewUnitTransferDocument($documentId: ID!, $decision: UnitTransferDocumentReviewDecisionEnumType!, $reason: String) {
    reviewUnitTransferDocument(documentId: $documentId, decision: $decision, reason: $reason) {
      id
      status
      rejectionReason
      reviewedAt
    }
  }
`);

const ReviewUnitTransferDocumentButtons: FC<{ documentId: string }> = ({ documentId }) => {
  const [showRejectDialog, toggleRejectDialog] = useState(false);
  const [reason, setReason] = useState('');
  const [reviewDocument, { loading, error }] = useMutation(REVIEW_UNIT_TRANSFER_DOCUMENT_MUTATION, {
    refetchQueries: ['getUnitTransferRequestDocuments'],
  });

  return (
    <div className="flex flex-row gap-2">
      <ConfirmButton
        loading={loading}
        error={error}
        description="Approve this document?"
        onConfirm={() =>
          reviewDocument({
            variables: { documentId, decision: UnitTransferDocumentReviewDecisionEnumType.Approve },
          })
        }
      >
        Approve
      </ConfirmButton>
      <Button variant="secondary" onClick={() => toggleRejectDialog(true)}>
        Reject
      </Button>
      <Dialog open={showRejectDialog} onClose={() => toggleRejectDialog(false)}>
        <DialogPanel>
          <DialogTitle>Reject Document</DialogTitle>
          <TextArea
            label="Reason"
            value={reason}
            onChange={e => setReason(e.target.value)}
            fullWidth
          />
          {error && <ErrorMessage error={error} type="alert" />}
          <DialogActions>
            <Button variant="secondary" onClick={() => toggleRejectDialog(false)}>
              Cancel
            </Button>
            <Button
              loading={loading}
              disabled={!reason}
              onClick={() =>
                reviewDocument({
                  variables: {
                    documentId,
                    decision: UnitTransferDocumentReviewDecisionEnumType.Reject,
                    reason,
                  },
                }).then(() => {
                  toggleRejectDialog(false);
                  setReason('');
                })
              }
            >
              Reject
            </Button>
          </DialogActions>
        </DialogPanel>
      </Dialog>
    </div>
  );
};

export default ReviewUnitTransferDocumentButtons;
